// extracted by css-extract-rspack-plugin
export default {"UpsellPageContent":"BaseUpsellPage-module__UpsellPageContent___iC3aY"};